import cn from 'classnames';
import { Button } from 'components/Button';
import { getQaDataAttr } from '@bygghemmait/utilities';
import styles from './toggleQuickstart.scss';

interface Props {
  label: string;
  onClick: () => void;
  className?: string;
  shouldDisableCardPaymentROTFeatureToggle?: boolean;
}

export const ToggleQuickstart = ({
  label,
  onClick,
  className,
  shouldDisableCardPaymentROTFeatureToggle = false
}: Props) => (
  <div className={cn(styles.toggleQuickstart, className)}>
    {shouldDisableCardPaymentROTFeatureToggle ? (
      <>{label}</>
    ) : (
      <>
        <Button
          onClick={onClick}
          appearance="link"
          type="button"
          {...getQaDataAttr('toggle-quickstart')}
        >
          {label}
        </Button>
      </>
    )}
  </div>
);
